import { FaFileInvoice } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../Tooltip";

function SummaryCards({ summaryData, onClick, setSelectedId, selectedId }) {

    const currentDueData = [
        {
            amount: "₹" + (summaryData?.totalDues || 0),
            label: "Total Dues",
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'TD',
        },

        {
            amount: "₹" + (summaryData?.rentDues || 0),
            label: `Rent Dues`,
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'CRD',
        },
        {
            amount: "₹" + (summaryData?.utilityDues || 0),
            label: `Utility Dues`,
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'CUD',
        },
        {
            amount: "₹" + (summaryData?.otherDueAmt || 0),
            label: `Other Dues`,
            color: "text-black",
            subLabel: `Fine Due`,
            subTitle: (summaryData?.fineDuesAmt || '0'),
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'COD',
        },
        {
            amount: "₹" + (summaryData?.securityShortFall || 0),
            label: `Security Shortfall`,
            color: "text-black",
            icon: <FaFileInvoice className="text-red-400" />,
            filter: 'SSD',
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {currentDueData.map((item) => {
                    const selected = selectedId === item.filter && item.filter !== ""
                    return (
                        <Card
                            key={item.label}
                            $selected={selected}
                            onClick={() => {
                                onClick(item.filter);

                            }

                            }>
                            <ValueRow>
                                <div className='flex flex-row'>
                                    <Value color={item.color}>{item.amount}</Value>
                                    {item.subTitle &&
                                        <Tooltip label={item.subLabel}>
                                            <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                            <span className="cursor-help text-gray-400 text-xs">ⓘ</span>
                                        </Tooltip>
                                    }
                                </div>
                            </ValueRow>
                            <Label>
                                {item.label}
                                <ArrowWrap className="arrow">
                                    <Chevron />
                                </ArrowWrap>
                            </Label>
                        </Card>
                    )
                })}
            </ScrollCard>
        </Wrapper>
    );
}

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;
const ValueRow = tw.div`
  flex items-baseline gap-1
`;
const Value = tw.div`
  text-2xl font-semibold text-gray-900
`;
const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;
const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;
const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;
